import PropTypes from 'prop-types';

import Skeleton from '@zenbusiness/zui/Skeleton';
import SkeletonText from '@zenbusiness/zui/SkeletonText';

import { HomeSection } from '#client/components/Section';

function LoadingState({ titleId }) {
  return (
    <HomeSection
      loading
      titleId={titleId}
      slots={{
        aside: <SkeletonText animation="wave" height={24} width="6rem" />,
      }}
    >
      <Skeleton role="img" height={200} />
    </HomeSection>
  );
}

LoadingState.propTypes = {
  titleId: PropTypes.string,
};

export default LoadingState;
